import { render, staticRenderFns } from "./ToDoCategoryForm.vue?vue&type=template&id=1fdfdbea&"
import script from "./ToDoCategoryForm.vue?vue&type=script&lang=js&"
export * from "./ToDoCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports